<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';

interface PageBlok {
    _uid: string;
    body: any[];
}

defineProps<{ blok: PageBlok }>();
</script>

<template>
    <div v-editable="blok">
        <StoryblokComponent v-for="childBlok in blok.body ?? []" :key="childBlok._uid" :blok="childBlok" />
    </div>
</template>
